import { NgModule } from '@angular/core';
import { RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha-2';

import { RecaptchaProviderService } from './recaptcha-provider.service';

@NgModule({
  imports: [RecaptchaV3Module],
  providers: [ReCaptchaV3Service, RecaptchaProviderService],
  exports: [RecaptchaV3Module],
})
export class RecaptchaProviderModule {}
